module.exports = __webpack_public_path__ + "static/media/igo.c7348669.svg";